import { render, staticRenderFns } from "./pendingMatches.vue?vue&type=template&id=83b63bac&lang=pug&"
import script from "./pendingMatches.vue?vue&type=script&lang=js&"
export * from "./pendingMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports